import { cloneDeep } from '_utils';
import CommentService from '_services/rest/modules/comment';
import { MODEL } from './components/CommentModel';

export default {
  state: {
    commentList: {
      list: [],
      total_items: null,
    },
    commentEdit: null,
    statuses: [
      { value: 'new', name: 'Novo' },
      { value: 'approved', name: 'Aprovado' },
      { value: 'rejected', name: 'Rejeitado' },
    ],
  },

  mutations: {
    setCommentList(state, response) {
      state.commentList = response;
    },
    setComment(state, response) {
      state.commentEdit = Object.assign(cloneDeep(MODEL), response);
    },
  },

  actions: {
    saveComment({ commit }, user) {
      return CommentService.save(user).then(response => {
        commit('updateComment', user);
        return response;
      });
    },
    getCommentList({ commit }, params) {
      return CommentService.getList(params)
        .then(response => {
          commit('setCommentList', response);
        });
    },
  },
};
